import React, { memo } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';

// local imports
import { useTranslation } from '@shared/core';

// interfaces
interface TravelMetricProps
  extends Readonly<{
    icon: React.ComponentType<{ size: number; color: string }>;
    value: string;
    unitLabel: string;
  }> {}

export const TravelMetric = memo<TravelMetricProps>(({ icon: Icon, value, unitLabel }) => {
  const { tq } = useTranslation('sharedComponents');

  return (
    <Flex
      gap={1}
      alignItems="center"
    >
      <Icon
        size={14}
        color="white"
      />
      <TextV2
        fontSize={14}
        color="white"
        typographyVariant="body1"
      >
        {tq`${value} ${unitLabel}`}
      </TextV2>
    </Flex>
  );
});

TravelMetric.displayName = 'TravelMetric';
